import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_8011",
	"data-name": "Group 8011",
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_39",
			"data-name": "Rectangle 39",
			fill: "#fff",
			stroke: "#000",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 35,
				height: 35,
				fill: "none"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_19423",
			"data-name": "Path 19423",
			d: "M16.1,0,9,7.832,1.9,0H0L8.048,8.886,0,17.771H1.9L9,9.939l7.1,7.832H18L9.952,8.886,18,0Z",
			transform: "translate(9 9.102)"
		})
	]
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
